"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _shortId = _interopRequireDefault(require("../utils/shortId"));
var _StyleConfig = require("../utils/StyleConfig");
var _useUpdatesOnlyEffect = _interopRequireDefault(require("../utils/useUpdatesOnlyEffect"));
var _OnClickOutsideWrapper = _interopRequireDefault(require("../utils/_OnClickOutsideWrapper"));
var _Popper = _interopRequireDefault(require("../utils/_Popper"));
var _useFocusManager = _interopRequireDefault(require("../utils/useFocusManager"));
var _OverlayConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Overlay-concur_android.css") : void 0);
var _OverlayConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Overlay-concur_default.css") : void 0);
var _OverlayConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Overlay-concur_gateway.css") : void 0);
var _OverlayConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Overlay-concur_ios.css") : void 0);
var _OverlaySap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Overlay-sap_fiori_3_dark.css") : void 0);
var _OverlaySap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Overlay-sap_fiori_3_hcb.css") : void 0);
var _OverlaySap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Overlay-sap_fiori_3_hcw.css") : void 0);
var _OverlaySap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Overlay-sap_fiori_3.css") : void 0);
var _OverlaySap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Overlay-sap_horizon_dark.css") : void 0);
var _OverlaySap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Overlay-sap_horizon_hcb.css") : void 0);
var _OverlaySap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Overlay-sap_horizon_hcw.css") : void 0);
var _OverlaySap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Overlay-sap_horizon.css") : void 0);
var _excluded = ["arrowClassName", "children", "className", "classNameMap", "customContainerRef", "disableEdgeDetection", "disableFocusManager", "disableHideWhenTargetIsHidden", "disablePortal", "flipContainer", "focusManagerProps", "focusRef", "hideShadow", "id", "innerDialogClassName", "maxWidth", "offset", "popperContentProps", "popperMiddleware", "popperPlacement", "popperProps", "renderTargetComponent", "show", "showArrow", "skidding", "skipTargetModifications", "targetClassName", "targetComponent", "targetProps", "width", "widthSizingType", "onClickOutside", "onEscapeKey", "onHide", "onKeyDown", "onShow"],
  _excluded2 = ["className"];
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  concur_android: _OverlayConcur_android.default,
  concur_default: _OverlayConcur_default.default,
  concur_gateway: _OverlayConcur_gateway.default,
  concur_ios: _OverlayConcur_ios.default,
  sap_fiori_3_dark: _OverlaySap_fiori_3_dark.default,
  sap_fiori_3_hcb: _OverlaySap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _OverlaySap_fiori_3_hcw.default,
  sap_fiori_3: _OverlaySap_fiori_.default,
  sap_horizon_dark: _OverlaySap_horizon_dark.default,
  sap_horizon_hcb: _OverlaySap_horizon_hcb.default,
  sap_horizon_hcw: _OverlaySap_horizon_hcw.default,
  sap_horizon: _OverlaySap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-overlay';

/**
 * Overlay is a generic popover-like component that can be used to render
 * content not typically available in the DOM. The Overlay content can be
 * rendered and shown on either click or hover events and be focus trapped
 * like an HTML dialog.
 */
var Overlay = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _classnames, _width$trim;
  var arrowClassName = _ref.arrowClassName,
    children = _ref.children,
    className = _ref.className,
    classNameMap = _ref.classNameMap,
    customContainerRef = _ref.customContainerRef,
    disableEdgeDetection = _ref.disableEdgeDetection,
    disableFocusManager = _ref.disableFocusManager,
    disableHideWhenTargetIsHidden = _ref.disableHideWhenTargetIsHidden,
    disablePortal = _ref.disablePortal,
    flipContainer = _ref.flipContainer,
    focusManagerProps = _ref.focusManagerProps,
    focusRef = _ref.focusRef,
    hideShadow = _ref.hideShadow,
    id = _ref.id,
    innerDialogClassName = _ref.innerDialogClassName,
    maxWidth = _ref.maxWidth,
    offset = _ref.offset,
    popperContentProps = _ref.popperContentProps,
    popperMiddleware = _ref.popperMiddleware,
    popperPlacement = _ref.popperPlacement,
    popperProps = _ref.popperProps,
    renderTargetComponent = _ref.renderTargetComponent,
    showProp = _ref.show,
    showArrow = _ref.showArrow,
    skidding = _ref.skidding,
    skipTargetModifications = _ref.skipTargetModifications,
    targetClassName = _ref.targetClassName,
    targetComponent = _ref.targetComponent,
    targetProps = _ref.targetProps,
    width = _ref.width,
    widthSizingType = _ref.widthSizingType,
    onClickOutside = _ref.onClickOutside,
    _onEscapeKey = _ref.onEscapeKey,
    onHide = _ref.onHide,
    onKeyDown = _ref.onKeyDown,
    onShow = _ref.onShow,
    otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(showProp),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var popoverRef = (0, _react.useRef)(null);
  var internalTargetRef = (0, _react.useRef)(null);
  var classnames = _bind.default.bind(classNameMap);
  var _id = (0, _react.useRef)(id || _shortId.default.generate());
  var handleClickOutside = function handleClickOutside(event) {
    var _document, _document$querySelect, _popoverRef$current, _popoverRef$current$g, _overlays$0$getAttrib, _overlays$;
    var target = event.target;

    // if there are multiple overlays and we are processing the click
    // for the first overlay, let's skip it so the other overlays
    // can handle it.
    var overlays = (_document = document) === null || _document === void 0 || (_document$querySelect = _document.querySelectorAll) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.call(_document, 'div[data-overlay]');
    if (overlays.length > 1 && ((_popoverRef$current = popoverRef.current) === null || _popoverRef$current === void 0 || (_popoverRef$current$g = _popoverRef$current.getAttribute) === null || _popoverRef$current$g === void 0 ? void 0 : _popoverRef$current$g.call(_popoverRef$current, 'data-overlay')) === ((_overlays$0$getAttrib = (_overlays$ = overlays[0]).getAttribute) === null || _overlays$0$getAttrib === void 0 ? void 0 : _overlays$0$getAttrib.call(_overlays$, 'data-overlay'))) {
      return;
    }
    var targetIsOutside;
    var targetIsTrigger;
    if (typeof target !== 'undefined') {
      var _popoverRef$current2, _popoverRef$current2$, _internalTargetRef$cu, _internalTargetRef$cu2;
      targetIsOutside = !(popoverRef !== null && popoverRef !== void 0 && (_popoverRef$current2 = popoverRef.current) !== null && _popoverRef$current2 !== void 0 && (_popoverRef$current2$ = _popoverRef$current2.contains) !== null && _popoverRef$current2$ !== void 0 && _popoverRef$current2$.call(_popoverRef$current2, target));
      targetIsTrigger = !!(target === (internalTargetRef === null || internalTargetRef === void 0 ? void 0 : internalTargetRef.current) || internalTargetRef !== null && internalTargetRef !== void 0 && (_internalTargetRef$cu = internalTargetRef.current) !== null && _internalTargetRef$cu !== void 0 && (_internalTargetRef$cu2 = _internalTargetRef$cu.contains) !== null && _internalTargetRef$cu2 !== void 0 && _internalTargetRef$cu2.call(_internalTargetRef$cu, target));
    }
    if (!targetIsOutside || targetIsTrigger) {
      // don't close if inside clicked or target clicked
      return;
    }
    // let user decide
    var userShows = !!(onClickOutside !== null && onClickOutside !== void 0 && onClickOutside(event));
    if (popoverRef !== null && popoverRef !== void 0 && popoverRef.current) {
      setShow(userShows);
    }
  };
  (0, _useFocusManager.default)(_objectSpread({
    firstFocusIndex: 0
  }, focusManagerProps), !disableFocusManager && show, popoverRef);
  (0, _useUpdatesOnlyEffect.default)(function () {
    if (show) {
      onShow === null || onShow === void 0 || onShow();
    } else {
      onHide === null || onHide === void 0 || onHide();
    }
  }, [show]);

  // map props to state
  (0, _react.useEffect)(function () {
    setShow(showProp);
  }, [showProp]);
  var popperClassName = classnames(CSS_BLOCK, className, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--custom-size"), !!width), (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--arrow"), !hideShadow && showArrow), (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--no-shadow"), hideShadow), _classnames));
  var target;
  if (targetComponent) {
    var _targetComponent$prop, _targetComponent$prop4;
    target = skipTargetModifications ? /*#__PURE__*/_react.default.cloneElement(targetComponent, {
      ref: (0, _reactMergeRefs.default)([targetComponent === null || targetComponent === void 0 ? void 0 : targetComponent.ref, internalTargetRef])
    }) : /*#__PURE__*/_react.default.cloneElement(targetComponent, {
      'aria-controls': show ? _id.current : null,
      'aria-expanded': show,
      'aria-haspopup': (targetComponent === null || targetComponent === void 0 || (_targetComponent$prop = targetComponent.props) === null || _targetComponent$prop === void 0 ? void 0 : _targetComponent$prop['aria-haspopup']) || 'dialog',
      onClick: (0, _chainFunction.default)(function () {
        var _targetComponent$prop2, _targetComponent$prop3;
        if (!show && !(targetComponent !== null && targetComponent !== void 0 && (_targetComponent$prop2 = targetComponent.props) !== null && _targetComponent$prop2 !== void 0 && _targetComponent$prop2.disabled) && !(targetComponent !== null && targetComponent !== void 0 && (_targetComponent$prop3 = targetComponent.props) !== null && _targetComponent$prop3 !== void 0 && _targetComponent$prop3.readOnly)) {
          setShow(true);
        }
      }, targetComponent === null || targetComponent === void 0 || (_targetComponent$prop4 = targetComponent.props) === null || _targetComponent$prop4 === void 0 ? void 0 : _targetComponent$prop4.onClick),
      ref: (0, _reactMergeRefs.default)([targetComponent === null || targetComponent === void 0 ? void 0 : targetComponent.ref, internalTargetRef])
    });
  }
  var _ref2 = popperContentProps || {},
    popperContentClassName = _ref2.className,
    otherPopperContentProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  var popperStyleProps = popperProps === null || popperProps === void 0 ? void 0 : popperProps.style;
  if (width !== null && width !== void 0 && (_width$trim = (0, _trim.default)(width)) !== null && _width$trim !== void 0 && _width$trim.call(width)) {
    popperStyleProps = _objectSpread(_objectSpread({}, popperStyleProps), {}, {
      width: width
    });
  }
  var extendedPopperProps = _objectSpread(_objectSpread(_objectSpread({
    'data-testid': _id.current,
    id: _id.current,
    role: 'dialog'
  }, otherProps), popperProps), {}, {
    innerRef: (0, _reactMergeRefs.default)([ref, popperProps === null || popperProps === void 0 ? void 0 : popperProps.innerRef]),
    style: popperStyleProps
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Popper.default, {
    arrowClassName: classnames("".concat(CSS_BLOCK, "__arrow"), arrowClassName),
    disableHideWhenTargetIsHidden: disableHideWhenTargetIsHidden,
    flipContainer: flipContainer,
    offset: offset,
    onEscapeKey: function onEscapeKey(event) {
      var _internalTargetRef$cu3, _internalTargetRef$cu4, _focusRef$current, _focusRef$current$foc;
      setShow(false);
      internalTargetRef === null || internalTargetRef === void 0 || (_internalTargetRef$cu3 = internalTargetRef.current) === null || _internalTargetRef$cu3 === void 0 || (_internalTargetRef$cu4 = _internalTargetRef$cu3.focus) === null || _internalTargetRef$cu4 === void 0 || _internalTargetRef$cu4.call(_internalTargetRef$cu3);
      focusRef === null || focusRef === void 0 || (_focusRef$current = focusRef.current) === null || _focusRef$current === void 0 || (_focusRef$current$foc = _focusRef$current.focus) === null || _focusRef$current$foc === void 0 || _focusRef$current$foc.call(_focusRef$current);
      _onEscapeKey === null || _onEscapeKey === void 0 || _onEscapeKey(event);
    },
    maxWidth: maxWidth,
    popperClassName: popperClassName,
    popperContentProps: _objectSpread(_objectSpread({}, otherPopperContentProps), {}, {
      className: classnames("".concat(CSS_BLOCK, "__wrapper"), popperContentClassName)
    }),
    popperMiddleware: popperMiddleware,
    popperPlacement: popperPlacement,
    popperProps: extendedPopperProps,
    renderTargetComponent: renderTargetComponent,
    show: children && show,
    showArrow: showArrow,
    targetClassName: targetClassName,
    targetComponent: target,
    targetProps: targetProps,
    widthSizingType: widthSizingType,
    skidding: skidding,
    onKeyDown: onKeyDown,
    disablePopperContainer: disablePortal,
    disableEdgeDetection: disableEdgeDetection,
    customContainer: customContainerRef
  }, /*#__PURE__*/_react.default.createElement(_OnClickOutsideWrapper.default, {
    handleClickOutside: handleClickOutside
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-overlay": _id.current,
    ref: popoverRef,
    className: classnames("".concat(CSS_BLOCK, "__dialog"), innerDialogClassName)
  }, children))));
});
Overlay.displayName = 'Overlay';
Overlay.propTypes = {
  /**
   * Overlay contents as a React node.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Additional classes for the Overlay's arrow.
   */
  arrowClassName: _propTypes.default.string,
  /**
   * Additional classes for the Overlay's dialog.
   */
  className: _propTypes.default.string,
  /**
   * When `disablePortal` is **false** or unset,
   * use `customContainerRef` (set to a React reference) to render the Overlay dialog
   * in a custom DOM element that customContainerRef refers too.
   */
  customContainerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /**
   * Set to **true** to prevent the Overlay dialog
   * from flipping when it hits the `Overlay.flipContainer`
   * boundary. If unset, the Overlay will try to
   * flip around and position itself where space is available.
   */
  disableEdgeDetection: _propTypes.default.bool,
  /**
   * For an accessible keyboard experience,
   * the Overlay component manages focus by:
   *
   * * setting focus to first focusable element on open
   * * keeping focus trapped within the Overlay when open
   *
   * Set to **true** to disable this behavior and implement
   * your own.
   * */
  disableFocusManager: _propTypes.default.bool,
  /**
   * Set to **true** to show the Overlay's dialog
   * even when the target is out-of-view, for example
   * when user scrolls away too far.
   */
  disableHideWhenTargetIsHidden: _propTypes.default.bool,
  /**
   * Set to **true** to render the Overlay dialog
   * after its target in the DOM. If unset,
   * a React.Portal is used to render this dialog
   * as the last child of BODY in the DOM.
   */
  disablePortal: _propTypes.default.bool,
  /** Used to create a boundary for the underlying Popper to stay within
   * by flipping.
  */
  flipContainer: _CustomPropTypes.default.elementOrArrayOfElements(),
  /**
   * Set to **true** to hide CSS box-shadows
   * on the Overlay's dialog.
   * */
  hideShadow: _propTypes.default.bool,
  /**
   * ID for the Overlay's dialog.
   * Used for accessibility binding.
   * A generated value will be used
   * if unset.
   */
  id: _propTypes.default.string,
  /** Additional classes for the Overlay's inner dialog. */
  innerDialogClassName: _propTypes.default.string,
  /**
   * Numerical maxWidth for the Overlay dialog.
   * Number is converted to pixel.
   */
  maxWidth: _propTypes.default.number,
  /**
   * Numerical offset for displacing the Overlay
   * relative to its position, away from the target.
   * Number is converted to pixel.
   */
  offset: _propTypes.default.number,
  /**
   * Additional props to spread to the Overlay's
   * dialog's content DIV.
   */
  popperContentProps: _propTypes.default.object,
  /** Placement of the Overlay dialog relative to its target element.
   * Options are `'top'`, `'top-start'`, `'top-end'`, `'bottom'`, `'bottom-start'`,
   * `'bottom-end'`, `'left'`, `'left-start'`, `'left-end'`, `'right'`,
   * `'right-start'`, `'right-end'`.
  */
  popperPlacement: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOf(_StyleConfig.POPPER_PLACEMENTS)), _propTypes.default.oneOf(_StyleConfig.POPPER_PLACEMENTS)]),
  /**
   * Additional props to spread to the Overlay's
   * dialog.
   */
  popperProps: _propTypes.default.object,
  /**
   * Set to **true** to show the Overlay's dialog.
   */
  show: _propTypes.default.bool,
  /**
   * Set to **true** to show an arrow pointing
   * to the Overlay's target/trigger.
   * */
  showArrow: _propTypes.default.bool,
  /**
   * Additional classes for the Overlay's
   * target wrapper DIV.
   */
  targetClassName: _propTypes.default.string,
  /**
   * Overlay trigger as a React node.
   * A `<Button />` is recommended.
   */
  targetComponent: _propTypes.default.node,
  /**
   * Render prop to provide callback function for rendering
   * target component.  Function will be passed ref from
   * the Popper render function so it can be applied to
   * any node.
   */
  renderTargetComponent: _propTypes.default.func,
  /**
   * Additional props to spread to the Overlay's
   * target wrapper DIV.
   */
  targetProps: _propTypes.default.object,
  /**
   * The custom width of the Overlay's dialog.
   * The value must specify the units as well as
   * the value (e.g. `200px`, `40vw` or `30%`).
   * When a custom width is used, the
   * dialog receives a maximum height and content
   * within the popover will scroll,
   * if necessary.
   * */
  width: _propTypes.default.string,
  /**
   * The width of the Overlay dialog relative to the target.
   *
   * * `none`: Overlay width will be equal to content width.
   * * `matchTarget`: Overlay width will always be equal to size of the target.
   * * `minTarget`: Overlay width will be more than or equal to size of the target.
   * * `maxTarget`: Overlay width will be less than or equal to size of the target.
   *  */
  widthSizingType: _propTypes.default.oneOf(_StyleConfig.POPPER_WIDTH_SIZING),
  /** @ignore set internally one. */
  focusManagerProps: _propTypes.default.object,
  /** @ignore set internally only. */
  popperMiddleware: _propTypes.default.array,
  /** @ignore set internally only. */
  skidding: _propTypes.default.number,
  /** @ignore set internally only. */
  skipTargetModifications: _propTypes.default.bool,
  /** @ignore set internally only. */
  focusRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /**
   * Callback function for when the Overlay closes.
   */
  onHide: _propTypes.default.func,
  /**
   * Callback function for when the Overlay opens.
   */
  onShow: _propTypes.default.func,
  /**
   * Callback function for ESC keydown event
   * encountered inside the Overlay.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * */
  onEscapeKey: _propTypes.default.func,
  /**
   * Callback function for keydown events
   * encountered inside the Overlay.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * */
  onKeyDown: _propTypes.default.func,
  /**
   * Callback function for a
   * click event encountered on an element
   * that is outside the Overlay but is
   * not the Overlay target. Its return value will be
   * converted to a boolean and used to determine if
   * the dialog should be closed in such an event.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {Boolean} - returning `true` will NOT hide the Overlay dialog
   */
  onClickOutside: _propTypes.default.func
};
Overlay.defaultProps = {
  offset: 1,
  popperContentProps: {},
  popperPlacement: ['bottom-start', 'top-start', 'bottom-end', 'top-end', 'auto'],
  popperProps: {},
  show: false,
  onHide: function onHide() {},
  onShow: function onShow() {},
  widthSizingType: 'none',
  onKeyDown: function onKeyDown() {}
};
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(Overlay);
exports.default = _default;